export default __webpack_public_path__ + "static/media/news55.ad25336f.jpg";